import * as Router from '../router/actions';
import {Actions as Common} from './commonActions';
import {Actions as MessageBox} from './messageBox/actions';
import {Actions as Session} from '../session/actions';
import {Actions as Menu} from './menu/actions';
import {Actions as Provider} from '../provider/actions';
import {Actions as Origin} from '../origin/actions';
import {Actions as Parameters} from '../parameter/actions';
import {Actions as Order} from '../order/actions';
import {Actions as ProviderConfig} from '../providerConfiguration/actions';
import {Actions as ExcelReader} from '../excelReader/actions';
import {Actions as Parts} from '../part/actions';
import {Actions as MonthClose} from '../monthClose/actions';
import {Actions as BackOrders} from '../backOrders/actions';
import {Actions as Binning} from '../binning/actions';
import {Actions as Transfers} from '../transfers/actions';
import {Actions as Warehouses} from '../warehouses/actions';
import {Actions as ItemBudget} from '../itemBudget/actions';
import {Actions as PartsMaster} from '../partsMaster/actions';
import {Actions as Lubricants} from '../lubricants/actions';
import {Actions as Picking} from '../picking/actions';
import {Actions as Transport} from '../transport/actions';
import {Actions as PartQuotation} from '../partQuotation/actions';
import {Actions as ProviderOrders} from '../providerOrders/actions';
import {Actions as ObsolescenceParameters} from '../obsolescenceParameters/actions';
import {Actions as VehiclesAvailability} from '../vehiclesAvailability/actions';
import {Actions as QualityAssuranceOrders} from '../qualityAssuranceOrders/actions';
import {Actions as SalesAndBudgetsLoad} from '../salesAndBudgetsLoad/actions';
import {Actions as ServiceReportPart} from '../serviceReportPart/actions';
import {Actions as VehicleEfficiency} from '../vehicleEfficiency/actions';
import {Actions as InvoiceLoad} from '../invoiceLoad/actions';
import {Actions as PartNumberCode} from '../partNumberCode/actions';
import {Actions as LogisticsReports} from '../logisticsReports/actions';
import {Actions as StockAdjustment} from '../stockAdjustment/actions';
import {Actions as LogisticOrders} from '../logisticsOrders/actions';
import {Actions as VehicleHistory} from '../vehicleHistory/actions';
import {Actions as ProcessedWarranty} from '../twcConsulty/actions';
import {Actions as TwcMaintenance} from '../twcMaintenance/actions';
import {Actions as WarrantyAdmin} from '../adminWarranty/actions';
import {Actions as VehicleCombos} from '../vehicleCombos/actions';
import {Actions as MasterVehicle} from '../masterVehicle/actions';
import {Actions as InvoiceQuery} from '../invoiceQuery/actions';
import {Actions as PartInvoices} from '../partInvoices/actions';
import {Actions as SpecialParts} from '../specialParts/actions';
import {Actions as DealerOrders} from '../dealerOrders/actions';
import {Actions as PartsCatalog} from '../partsCatalog/actions';
import {Actions as PriceFactors} from '../priceFactors/actions';
import {Actions as PartsReturns} from '../partsReturns/actions';
import {Actions as VehiclesKpi} from '../vehiclesKpi/actions';
import {Actions as Accessories} from '../accessories/actions';
import {Actions as CalendarTems} from '../calendar/actions';
import {Actions as PartsSales} from '../partsSales/actions';
import {Actions as Warranties} from '../warranties/actions';
import {Actions as WholeSale} from '../wholeSale/actions';
import {Actions as PartAudit} from '../partAudit/actions';
import {Actions as IccMatrix} from '../iccMatrix/actions';
import {Actions as WaitHappy} from '../waitHappy/actions';
import {Actions as Campaign} from '../campaign/actions';
import {Actions as BoReport} from '../boReport/actions';
import {Actions as VehAudi} from '../vehAudi/actions';
import {Actions as Dealer} from '../dealer/actions';
import {Actions as Icc} from '../iccChart/actions';
import {Actions as Forms} from '../forms/actions';
import {Actions as Users} from '../user/actions';
import {Actions as UsersList} from '../users/actions';
import {Actions as Sets} from '../sets/actions';
import {Actions as Kpis} from '../kpis/actions';
import {Actions as Liquidations} from '../liquidations/actions';
import {Actions as BudgetVehicles} from '../budgetVehicles/actions';
import {Actions as VehicleSaleForecastActions} from '../vehicleSaleForecast/actions';
import {Actions as DailyVehiclesSalesAndStock} from '../dailyVehiclesSalesAndStock/actions';
import {Actions as VehicleCertification} from '../vehicleCertification/actions';
import {Actions as DailyVehiclesSalesAndStockSummary} from '../dailyVehiclesSalesAndStockSummary/actions';
import {Actions as AnticipatedInvoiceVehicles} from '../anticipatedInvoiceVehicles/actions';
import {Actions as DispatchOrders} from '../dispatchOrders/actions';
import {Actions as DevicesOrders} from '../devices/actions';
import {Actions as DailyVehiclesSalesAndStockWholesale} from '../dailyVehiclesSalesAndStockWholesale/actions';
import {Actions as ManageOrders} from '../manageOrders/actions';
import {Actions as VehiclesInventory} from '../vehiclesInventory/actions';
import {Actions as PartsImports} from '../partsImports/actions';
import {Actions as MailGroupActions} from '../mailGroup/actions';
import {Actions as AccessoriesRequests} from '../accessoriesRequests/actions';
import {Actions as Bulletins} from '../bulletins/actions';
import {Actions as CombosActions} from '../combos/actions';
import {Actions as TransportistActions} from '../transportist/actions';
import {Actions as AgenciesActions} from '../agencies/actions';
import {Actions as VehiclesPriorization} from '../vehiclesPriorization/actions';
import {Actions as CustomerTracking} from '../customerTracking/actions';
import {Actions as Technicians} from '../logisticTechnicians/actions';
import {Actions as LogisticAreas} from '../logisticAreas/actions';
import {Actions as FloatingInventory} from '../floatingInventory/actions';
import {Actions as LogisticModels} from '../logisticModels/actions';
import {Actions as LogisticTasks} from '../logisticTasks/actions';
import {Actions as AccountReporter} from '../accountReporter/actions';
import {Actions as Wts} from '../wts/actions';
import {Actions as ReportPartsSalesJapan} from '../reportPartsSalesJapan/actions';
import {Actions as PartsLocationDashboard} from '../partsLocationDashboard/actions';
const Actions = {
  ...Router,
  ...Common,
  ...MessageBox,
  ...Session,
  ...Menu,
  ...Provider,
  ...Origin,
  ...Parameters,
  ...Order,
  ...ProviderConfig,
  ...ExcelReader,
  ...Parts,
  ...MonthClose,
  ...BackOrders,
  ...Binning,
  ...Transfers,
  ...Warehouses,
  ...ItemBudget,
  ...PartsMaster,
  ...Lubricants,
  ...Picking,
  ...Transport,
  ...InvoiceLoad,
  ...PartQuotation,
  ...SalesAndBudgetsLoad,
  ...PartsCatalog,
  ...ObsolescenceParameters,
  ...VehiclesAvailability,
  ...QualityAssuranceOrders,
  ...ServiceReportPart,
  ...VehicleEfficiency,
  ...ProcessedWarranty,
  ...LogisticsReports,
  ...VehicleHistory,
  ...LogisticOrders,
  ...PartNumberCode,
  ...StockAdjustment,
  ...ProviderOrders,
  ...WarrantyAdmin,
  ...PartsReturns,
  ...Accessories,
  ...Dealer,
  ...Forms,
  ...VehAudi,
  ...IccMatrix,
  ...BoReport,
  ...Icc,
  ...DealerOrders,
  ...PartsSales,
  ...PartAudit,
  ...PartInvoices,
  ...SpecialParts,
  ...PriceFactors,
  ...InvoiceQuery,
  ...WaitHappy,
  ...MasterVehicle,
  ...CalendarTems,
  ...WholeSale,
  ...Campaign,
  ...Users,
  ...Sets,
  ...Kpis,
  ...Liquidations,
  ...Warranties,
  ...VehiclesKpi,
  ...VehicleCombos,
  ...BudgetVehicles,
  ...TwcMaintenance,
  ...VehicleSaleForecastActions,
  ...DailyVehiclesSalesAndStock,
  ...VehicleCertification,
  ...DailyVehiclesSalesAndStockSummary,
  ...AnticipatedInvoiceVehicles,
  ...MailGroupActions,
  ...DispatchOrders,
  ...DevicesOrders,
  ...DailyVehiclesSalesAndStockWholesale,
  ...MailGroupActions,
  ...ManageOrders,
  ...UsersList,
  ...VehiclesInventory,
  ...PartsImports,
  ...AccessoriesRequests,
  ...Bulletins,
  ...CombosActions,
  ...TransportistActions,
  ...AgenciesActions,
  ...LogisticModels,
  ...VehiclesPriorization,
  ...LogisticAreas,
  ...CustomerTracking,
  ...Technicians,
  ...FloatingInventory,
  ...LogisticTasks,
  ...AccountReporter,
  ...Wts,
  ...ReportPartsSalesJapan,
  ...PartsLocationDashboard,
};

export {Actions};
